export default __webpack_public_path__ + "5c8366b215394c62134f5ec304fc91c8.png";